<sc-paged-content [configuration]="configuration" [data]="data" (addRequested)="onAddRequested()" (deleteRequested)="onDeleteRequested($event)" (selectionChanged)="onSelectionChanged($event)">
  <sc-no-data-container fitHeight [hasData]="currentEquipmentType">
    <app-equipment-admin-details [equipmentType]="currentEquipmentType" (changed)="onChanged()" (canceled)="onCancel()"></app-equipment-admin-details>
  </sc-no-data-container>
</sc-paged-content>
